import React from 'react';
import styled from 'styled-components';
import EntityListItem from './EntityListItem';
import Tag from './Tag';
import oh from 'output-helpers';
import api_helpers from '../../helpers/api_helpers';
import userInputs from 'user-inputs';
import withStore from 'with-store';

class TaskCard extends React.Component {

    constructor(props) {
        super(props);
        this.container = styled.div `
            display: inline-block;
            margin: 0 20px 20px 0;
            background-color: #fff;
            border-radius: 4px;
            border: 1px solid ${props => props.theme.colors.border};
            width: 280px;
            .task_head{
                .task_title, .task_action{
                    display: inline-block;
                    vertical-align: middle;
                }
                .task_title{
                    padding: 8px 12px;
                    font-size: 18px;
                    font-weight: bold;
                    width: 85%;
                }
                .task_action{
                    width: 15%;
                    text-align: right;
                    padding: 8px 4px;
                    svg{
                        width: 20px;
                        height: 20px;
                    }
                }
            }
            .task_tags{
                padding: 2px 12px;
            }
            .task_body{
                padding: 8px 12px 12px;
                .task_description{
                    font-size: 14px;
                    opacity: 0.6;
                }
            }
            .task_list{
                border-top: 1px solid ${props => props.theme.colors.border};
                ul{
                    li{
                        border-bottom: 1px solid ${props => props.theme.colors.border};
                        &:last-child{
                            border-radius: 0 0 4px 4px;
                            border-bottom: 0;
                        }
                    }
                }
            }

        `;

        this.entityOptions = (entity) => {
            let options = [];
            let selected_order = this.props.se.getSelectedOrder();
            let selected_task = this.props.store.tasks.by_id[entity.task_id];
            if (selected_order && selected_order.state !== "approved") {
                options.push({
                    label: oh.translate('change_state_completed'),
                    onClick: () => {
                        let altered_task = Object.assign({}, selected_task);
                        altered_task.completed = true;
                        withStore.actions.spinner.add();
                        api_helpers.updateTask(altered_task)
                            .then((updated_task) => {
                                this.props.actions.tasks.setTask(updated_task);
                            })
                            .finally(() => {
                                withStore.actions.spinner.remove();
                            });
                    }
                });
                options.push({
                    label: oh.translate('change_state_not_completed'),
                    onClick: () => {
                        let altered_task = Object.assign({}, selected_task);
                        altered_task.completed = false;
                        withStore.actions.spinner.add();
                        api_helpers.updateTask(altered_task)
                            .then((updated_task) => {
                                this.props.actions.tasks.setTask(updated_task);
                            })
                            .finally(() => {
                                withStore.actions.spinner.remove();
                            });
                    }
                });
            }
            let current_note = "";
            if (selected_task.data.hasOwnProperty("admin_note")) {
                current_note = selected_task.data.admin_note;
            }
            options.push({
                label: oh.translate('add_special_note'),
                onClick: () => {
                    this.props.userPrompt.confirm({
                        inputs: [
                            {
                                type: "textarea",
                                key: "admin_note",
                                label: oh.translate("enter_note_for") + ' ' + entity.id,
                                default_value: current_note
                            }
                        ]
                    }, (values) => {
                        let task = Object.assign({}, this.props.store.tasks.by_id[entity.task_id]);
                        let note = values.admin_note.trim();
                        if (note.length > 0) {
                            task.data.admin_note = note;
                            api_helpers.updateTask(task)
                                .then((task) => {
                                    this.props.actions.tasks.setTask(task);
                                });
                        }
                    });
                }
            });

            return options;
        };
    }

    render() {
        return (
            <this.container>
                <div className="task_head">
                    <p className="task_title">
                        {oh.translate(this.props.task.type)}
                    </p>
                </div>
                <div className="task_tags">
                    {
                        this.props.task.tags.map((item, i) => {
                            return (<Tag key={i} label={item.name}/>);
                         })
                    }
                </div>
                <div className="task_body">
                    <p className="task_description">
                        {this.props.task.data.description}
                    </p>
                </div>
                <div className="task_list">
                    <ul>
                        {
                            this.props.entities.map((entity, y) => {
                                entity.name = entity.id;
                                return (
                                    <EntityListItem
                                        option={{
                                            icon: 'menu',
                                            isDropdown: true,
                                            dropdownOptions: this.entityOptions(entity),
                                            onClick: () => {
                                                console.log('open menu');
                                            }
                                        }}
                                        onClickItem={() => {
                                            this.props.se.setSelectedEntity(entity.ref);
                                        }}
                                        key={y}
                                        entity={entity}
                                    />
                                );
                            })
                        }
                    </ul>
                </div>
            </this.container>
        );
    }
}

export default withStore(userInputs(TaskCard));



// WEBPACK FOOTER //
// ./src/components/base/TaskCard.jsx